// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ExclamationIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={2} height={10} viewBox="0 0 2 10" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="exclamation" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><path id="Combined-Shape" fill="currentColor" d="M0 8h2v2H0zm0-8h2v6H0z" /></g></svg>
))
